module.exports = __webpack_public_path__ + "img/BOB.4d357080.svg";